/* eslint-disable */
import { executeRequest, executeStaticRequest } from './http-client'
import { hostsConfig, turnToConfig } from 'init/config'
import * as staticCache from 'util/static-call-cache'

export interface Answer {
  id?: number
  text?: string
  catItem?: CatalogItem
  user?: User
  dateCreatedFormatted?: string
  dateCreatedMillis?: number
  replyToken?: string
  expertLabel?: string
  isStaff?: boolean
  isIndependentExpert?: boolean
  multiItems?: Array<CatalogItem>
  thanked?: boolean
  syndicationSourceSiteName?: string
  syndicationSourceSiteId?: number
  purchaseDateFormatted?: string
  purchaseDateMillis?: number
  replies?: Array<Reply>
}
export interface AnswerInitData {
  answerer?: User
  question?: Question
  token?: string
  userData?: string
}
export interface AddVideoLinkResponse {
  authorUrl?: string
  authorName?: string
  height?: number
  html?: string
  provider?: string
  providerId?: string
  providedLink?: string
  thumbnailUrl?: string
  thumbnailWidth?: number
  thumbnailHeight?: number
  timeRetrieved?: number
  width?: number
}
export interface Article {
  id?: number
  title?: string
  text?: string
}
export interface CatalogItem {
  id?: number
  title?: string
  imageId?: number
  imageProcessed?: boolean
  type?: number
  url?: string
  sku?: string
  attributes?: Array<{
    label?: string
    value?: string
  }>
}
export interface CreateCommentBody {
  email?: string
  siteCatalogItemId?: number
  siteUserId?: number
  transactionItemId: number
  text: string
}
export interface CreateMediaItemsBody {
  media?: Array<MediaForSave>
  catItemId?: number
}
export interface MediaForSave {
  caption?: string
  height?: number
  width?: number
  type?: 0 | 1
  imageId?: string
  imageType?: string
  orientation?: number
  authorUrl?: string
  authorName?: string
  durationMillis?: number
  html?: string
  provider?: string
  providerId?: string
  providedLink?: string
  thumbnailUrl?: string
  thumbnailWidth?: number
  thumbnailHeight?: number
  timeRetrieved?: number
}
export interface ChatterCommentsResponse {
  total?: number
  comments?: Array<Comment>
}
export interface CommentsPinboardItem {
  id?: number
  title?: string
  imageId?: number
  imageProcessed?: boolean
  type?: number
  url?: string
  sku?: string
  attributes?: Array<{
    label?: string
    value?: string
  }>
  averageRating?: number
  reviewCount?: number
  commentsCount?: number
  comments?: Array<Comment>
}
export interface CreateAnswerBody {
  catItemId: number
  questionId: number
  text: string
  itemQuestionRecipientLogId?: number
  multiItemIds?: Array<number>
  sourceId?: 1 | 2
}
export interface CreateReplyBody {
  answerId: number
  catItemId: number
  parentReplyId?: number
  text: string
}
export interface CreateQuestionBody {
  text: string
  questionType: number
  multiItemIds?: Array<number>
}
export interface CreateTransactionBody {
  orderId?: string
  deliveryDate?: string
  email?: string
  emailOptOut?: boolean
  externalUserId?: string
  firstName?: string
  lastName?: string
  nickName?: string
  postalCode?: string
  items?: Array<CreateTransactionLineItem>
}
export interface CreateTransactionLineItem {
  lineItemId?: string
  itemImageUrl?: string
  price?: string
  siteKey?: string
  sku?: string
  title?: string
  url?: string
}
export interface CreateUserIdentityBody {
  email?: string
  isPrimary?: boolean
}
export interface CreateUserIdentityResponse {
  total?: number
  identities?: Array<UserIdentity>
}
export interface DeleteUserIdentityResponse {
  total?: number
  identities?: Array<UserIdentity>
}
export interface DoMoreCatalogItem {
  id?: number
  title?: string
  imageId?: number
  imageProcessed?: boolean
  type?: number
  url?: string
  sku?: string
  attributes?: Array<{
    label?: string
    value?: string
  }>
  unreviewedPurchase?: boolean
  questions?: Array<Question>
}
export interface GetCatalogItemsForCommentsPinboardResponse {
  hasMore?: boolean
  catalogItems?: Array<CommentsPinboardItem>
}
export interface GetCatalogItemsResponse {
  totalFound?: number
  items?: Array<CatalogItem>
}
export interface GetDoMoreContentResponse {
  answerer?: User
  catItems?: Array<DoMoreCatalogItem>
  total?: number
  token?: string
  userData?: string
}
export interface GetUserAnswersResponse {
  answers?: Array<Answer>
  total?: number
}
export interface GetUserCommentsResponse {
  comments?: Array<Comment>
  total?: number
}
export interface GetUserIdentitiesResponse {
  identities?: Array<UserIdentity>
}
export interface GetUserMediaResponse {
  media?: Array<Media>
  total?: number
}
export interface GetUserQuestionsResponse {
  questions?: Array<Question>
  total?: number
}
export interface GetUserReviewsResponse {
  reviews?: Array<Review>
  total?: number
}
export interface Comment {
  id?: number
  text?: string
  catItem?: CatalogItem
  user?: User
  dateCreatedFormatted?: string
  dateCreatedMillis?: number
}
export interface SearchResult {
  id?: number
  ugcType?: 'q' | 'ir' | 'k'
  text?: string
  itemTitle?: string
  title?: string
  rating?: number
  answerCount?: number
}
export interface SearchBody {
  catalogItemId?: number
  includeRelatedQuestions?: boolean
  includeRelatedReviews?: boolean
  searchTerm?: string
  sku?: string
  brand?: string
  categoryIds?: Array<number>
  isCategory?: boolean
}
export interface SearchResponse {
  total?: number
  items?: Array<SearchResult>
}
export interface Media {
  id?: number
  text?: string
  catItem?: CatalogItem
  user?: User
  dateCreatedFormatted?: string
  dateCreatedMillis?: number
  catItems?: Array<CatalogItem>
  type?: 0 | 1
  width?: number
  height?: number
  imageId?: string
  imageProcessed?: boolean
  imageType?: string
  orientation?: number
  durationMillis?: number
  durationFormatted?: string
  thumbnailUrl?: string
  thumbnailWidth?: number
  thumbnailHeight?: number
  html?: string
  upVotes?: number
}
export interface MediaInitData {
  catItem?: CatalogItem
  token?: string
  userData?: string
}
export interface MediaListResponse {
  total?: number
  media?: Array<{
    id?: number
    text?: string
    catItem?: CatalogItem
    user?: User
    dateCreatedFormatted?: string
    dateCreatedMillis?: number
    catItems?: Array<CatalogItem>
    type?: 0 | 1
    width?: number
    height?: number
    imageId?: string
    imageProcessed?: boolean
    imageType?: string
    orientation?: number
    durationMillis?: number
    durationFormatted?: string
    thumbnailUrl?: string
    thumbnailWidth?: number
    thumbnailHeight?: number
    html?: string
    upVotes?: number
    review?: {
      id?: number
      rating?: number
      title?: string
      text?: string
    }
  }>
}
export interface MediaSize {
  containerWidth?: number
  mediaSize?: number
}
export interface MediaUploadResponse {
  uploadId?: string
  imageId?: string
  imageType?: string
  width?: number
  height?: number
  orientation?: number
}
export interface Question {
  id?: number
  text?: string
  catItem?: CatalogItem
  user?: User
  dateCreatedFormatted?: string
  dateCreatedMillis?: number
  answerToken?: string
  isStaff?: boolean
  multiItems?: Array<CatalogItem>
  upVotes?: number
  syndicationSourceSiteName?: string
  syndicationSourceSiteId?: string
  answers?: Array<Answer>
}
export interface QuestionsListResponse {
  brand?: string
  catalogItemId?: number
  parentCategoryIds?: Array<number>
  total?: number
  questions?: Array<Question>
}
export interface RelatedQuestion {
  catItemId?: number
  isAutoadd?: boolean
  relationshipType?: string
  relatedQuestion?: Array<Question>
}
export interface RelatedQuestionsListResponse {
  total?: number
  relatedQuestions?: Array<RelatedQuestion>
}
export interface Reply {
  id?: number
  text?: string
  catItem?: CatalogItem
  user?: User
  dateCreatedFormatted?: string
  dateCreatedMillis?: number
  replyToken?: string
  expertLabel?: string
  isStaff?: boolean
  isIndependentExpert?: boolean
  syndicationSourceSiteName?: string
  syndicationSourceSiteId?: string
  replies?: Array<Reply>
}
export interface ReplyInitData {
  replier?: User
  question?: Question
  parentReplyId?: number
  token?: string
  userData?: string
}
export interface Review {
  id?: number
  text?: string
  catItem?: CatalogItem
  user?: User
  dateCreatedFormatted?: string
  dateCreatedMillis?: number
  rating?: number
  title?: string
  upVotes?: number
  downVotes?: number
  expertLabel?: string
  incentivized?: boolean
  isCreator?: boolean
  isIndependent?: boolean
  isStaff?: boolean
  locale?: string
  purchaseDateFormatted?: string
  recommend?: boolean
  dimensions?: Array<ReviewDimension>
  profileAttributes?: ReviewProfileAttributes
  media?: Array<Media>
  responsesBySource?: Array<{
    source?: string
    responses?: Array<ReviewResponse>
  }>
  syndication?: SyndicationAttribution
  updates?: Array<ReviewUpdate>
}
export interface ReviewDimension {
  type?: number
  dimensionLabel?: string
  value?: number
  valueLabels?: Array<string>
}
export interface ReviewProfileAttributes {
  ageRange?: string
  location?: string
  custom?: Array<{
    label?: string
    value?: string
  }>
}
export interface ReviewResponse {
  id?: number
  text?: string
  catItem?: CatalogItem
  user?: User
  dateCreatedFormatted?: string
  dateCreatedMillis?: number
  isStaff?: boolean
  expertLabel?: string
}
export interface ReviewUpdate {
  updateDateFormatted?: string
  text?: string
  rating?: number
}
export interface ReviewsListResponse {
  productReviewsJsonLdEnabled?: boolean
  brand?: string
  catalogItemId?: number
  catalogItemTitle?: string
  filters?: Array<Filter>
  parentCategoryIds?: Array<number>
  total?: number
  reviews?: Array<Review>
}
export interface ReviewForm {
  catItemId?: number
  acceptedTerms?: boolean
  deviceFingerprint?: string
  incentiveType?: string
  media?: Array<Media>
  rating?: number
  source?: 0 | 1 | 2
  title?: string
  text?: string
  recommend?: boolean
  sweepstakesOptIn?: boolean
  dimensions?: Array<ReviewFormDimensions>
  fromMobile?: boolean
  profile?: ReviewFormProfile
}
export interface ReviewFormDimensions {
  id?: number
  value?: any
}
export interface ReviewFormProfile {
  ageRange?: number
  ageRangeIsDirty?: boolean
  country?: string
  state?: string
  city?: string
  locationIsDirty?: boolean
  customAttributes?: Array<ReviewFormCustomAttributes>
}
export interface ReviewFormCustomAttributes {
  id?: number
  value?: any
}
export interface ReviewInitData {
  alreadyReviewed?: boolean
  purchasedItem?: boolean
  catItem?: CatalogItem
  dimensionDefinitions?: Array<ReviewInitDataDimension>
  inboxSubmissionFormData?: ReviewInboxFormData
  shopperProfile?: ShopperProfile
  sellerRatingTransactionId?: number
  token?: string
  userData?: string
  userMedia?: Array<Media>
  eriCampaign?: EriCampaign
}
export interface ReviewInboxFormData {
  rating?: number
  title?: string
  text?: string
  sweepstakesOptIn?: boolean
  dimensions?: Array<ReviewFormDimensions>
}
export interface ReviewInitDataDimension {
  id?: number
  type?: number
  label?: string
  required?: boolean
  displayAsTags?: boolean
  valueDefinitions?: Array<{
    id?: string
    label?: string
    value?: number
    imageId?: string
  }>
}
export interface SellerRatingForm {
  rating?: number
  source?: 0 | 1
  text?: string
  transactionId?: number
}
export interface SellerRatingInitData {
  alreadyReviewed?: boolean
  hasTransaction?: boolean
  logoFileName?: string
  token?: string
  userData?: string
}
export interface ShopperProfile {
  definitions?: ShopperProfileDefinitions
  values?: ShopperProfileValues
}
export interface ShopperProfileDefinitions {
  ageRange?: {
    required?: boolean
    ageRanges?: { [name: string]: string }
  }
  location?: {
    defaultCountry?: string
    required?: boolean
    countries?: { [name: string]: string }
    caProvinces?: { [name: string]: string }
    usStates?: { [name: string]: string }
  }
  customAttributes?: Array<ProfileAttributeDefinition>
}
export interface ProfileAttributeDefinition {
  id?: number
  type?: number
  label?: string
  required?: boolean
  displayAsTags?: boolean
  valueDefinitions?: Array<{
    id?: string
    label?: string
  }>
}
export interface ShopperProfileValues {
  ageRange?: string
  ageRangeIsDirty?: boolean
  country?: string
  state?: string
  city?: string
  customAttributes?: Array<ProfileAttributeValue>
}
export interface ProfileAttributeValue {
  id?: number
  valueDefinitionId?: string
  freeFormText?: string
}
export interface SiteUser {
  id?: number
  firstName?: string
  lastName?: string
  email?: string
}
export interface SpectrumResponse {
  sku?: string
  positiveCount?: number
  criticalCount?: number
  positiveReview?: Review
  criticalReview?: Review
}
export interface SsoRequest {
  submissionToken?: string
  action?: string
  userDataToken?: string
}
export interface SsoResponse {
  ugcId?: number
  token?: string
}
export interface SyndicationAttribution {
  sourceName?: string
  siteUrl?: string
  logoUrl?: string
}
export interface Ugc {
  id?: number
  text?: string
  catItem?: CatalogItem
  user?: User
  dateCreatedFormatted?: string
  dateCreatedMillis?: number
}
export interface UpdateCommentBody {
  siteCatalogItemId?: number
  text: string
}
export interface UpdateUserIdentityBody {
  isPrimary?: boolean
}
export interface UpdateUserIdentityResponse {
  total?: number
  identities?: Array<UserIdentity>
}
export interface User {
  id?: number
  nickName?: string
  firstName?: string
  lastName?: string
}
export interface UserIdentity {
  id?: number
  email?: string
  isConfirmed?: boolean
  isPrimary?: boolean
}
export interface UserProfile {
  id?: number
  nickName?: string
  firstName?: string
  lastName?: string
  country?: string
  city?: string
  state?: string
  ageRange?: number
  customAttributes?: Array<UserProfileAttributes>
}
export interface UserProfileAttributes {
  id?: number
  label?: string
  required?: boolean
  type?: number
  collectDuringContentSubmit?: boolean
  values?: Array<{
    id?: number
    label?: string
    value?: string
    sortOrder?: number
    hidden?: boolean
  }>
}
export interface UserUgcStats {
  totalReviews?: number
  totalReviewLikes?: number
  totalPhotosVideos?: number
  totalPhotoVideoLikes?: number
  totalQuestions?: number
  totalQuestionLikes?: number
  totalAnswers?: number
  totalAnswerLikes?: number
  totalCheckoutComments?: number
}
export interface VcPinboardResponse {
  total?: number
  media?: Array<VcPinboardItem>
}
export interface VcPinboardItem {
  id?: number
  text?: string
  catItem?: CatalogItem
  user?: User
  dateCreatedFormatted?: string
  dateCreatedMillis?: number
  catItems?: Array<CatalogItem>
  type?: 0 | 1
  width?: number
  height?: number
  imageId?: string
  imageProcessed?: boolean
  imageType?: string
  orientation?: number
  durationMillis?: number
  durationFormatted?: string
  thumbnailUrl?: string
  thumbnailWidth?: number
  thumbnailHeight?: number
  html?: string
  upVotes?: number
  averageRating?: number
  reviewCount?: number
}
export interface RegisterUserBody {
  email: string
  firstName?: string
  lastName?: string
  nickName?: string
  sku?: string
  savedContentToken?: string
  stagedContentToken?: string
}
export interface FieldError {
  code?: string
  path?: string
}
export interface RestError {
  status?: number
  errorCode?: string
  fieldErrors?: Array<FieldError>
}
export interface ReviewsSummaryResponse {
  catItem?: CatalogItem
  directReviewsCount?: number
  hideDisplay?: boolean
  reviewsCount?: number
  recommendedPercentageFormatted?: string
  rating?: number
  ratingFormatted?: string
  ratingsBreakdown?: Array<{
    rating?: number
    num?: number
    pctOfRatingsFormatted?: string
  }>
  relatedReviewsCount?: number
  customDimensions?: Array<SummaryDimension>
}
export interface SummaryDimension {
  dimensionDefinitionId?: number
  label?: string
  teaserLabel?: string
  type?: number
  average?: number
  values?: Array<SummaryDimensionValue>
}
export interface SummaryDimensionValue {
  id?: number
  label?: string
  count?: number
}
export interface TopCommentsResponse {
  [sku: string]: Array<Comment>
}
export interface TransactionItemsForCommentResponse {
  token?: string
  siteUser?: SiteUser
  items?: Array<TransactionItemForComment>
}
export interface TransactionItemForComment {
  transactionItemId?: number
  siteKey?: string
  existingCommentText?: string
  latestDateFormatted?: string
  catItem?: CatalogItem
}
export interface GalleryBreakpoint {
  viewport?: number
  size?: number
  showCaptions?: boolean
}
export interface ChatterBreakpoint {
  viewport?: number
  numOfCols?: number
  hSpacing?: number
  vSpacing?: number
}
export interface ChatterConfig {
  breakpointsConfig?: Array<ChatterBreakpoint>
  headingLevel?: number
  limit?: number
  minCount?: number
  minCharacterCount?: number
  minWordCount?: number
  truncateLength?: number
  truncateAllowance?: number
  includeSyndicated?: boolean
  sortOrder?: number
  widgetDivId?: string
}
export interface CommentCaptureConfig {
  delayDisplaySeconds?: number
  enabled?: boolean
  headingLevel?: number
  showUsername?: boolean
  embed?: boolean
  paginate?: boolean
  widgetDivId?: string
}
export interface CommentsPinboardBreakpoint {
  viewport?: number
  minWidth?: number
  maxWidth?: number
  hSpacing?: number
  vSpacing?: number
}
export interface CommentsPinboardConfig {
  activeOnly?: boolean
  breakpointsConfig?: Array<CommentsPinboardBreakpoint>
  commentMaxLength?: number
  hoverTitleMaxLength?: number
  includeSyndicated?: boolean
  limit?: number
  maxCommentsReturned?: number
  maxDaysOld?: number
  progressiveLoading?: boolean
  showReviewStars?: boolean
  titleMaxLength?: number
  userNameMaxLength?: number
  widgetDivId?: string
}
export interface CommentsPinboardTeaserBreakpoint {
  viewport?: number
  minWidth?: number
  commentLinesLimit?: number
  promoPlacement?: string
  spacing?: number
}
export interface CommentsPinboardTeaserConfig {
  activeOnly?: boolean
  breakpointsConfig?: Array<CommentsPinboardTeaserBreakpoint>
  commentMaxLength?: number
  hoverTitleMaxLength?: number
  includeSyndicated?: boolean
  maxDaysOld?: number
  promoButtonUrl?: string
  showReviewStars?: boolean
  titleMaxLength?: number
  userNameMaxLength?: number
  widgetDivId?: string
}
export interface FilterOption {
  value?: any
  label?: string
  labelKey?: string
  count?: number
}
export interface Filter {
  name?: string
  group?: string
  hidden?: boolean
  isRating?: boolean
  label?: string
  labelKey?: string
  showCounts?: boolean
  type?: 'boolean' | 'string' | 'number' | 'array'
  options?: Array<FilterOption>
}
export interface EmbeddedSubmissionConfig {
  headerImage?: string
  siteLink?: string
  turntoHosted?: boolean
  divId?: string
}
export interface GalleryConfig {
  arrowLocation?: 'top' | 'overlay' | 'bottom'
  arrowStyle?: 'button' | 'icon'
  breakpoints?: Array<GalleryBreakpoint>
  columnSpacing?: number
  headingLevel?: number
  includeProductSiblings?: boolean
  includeSyndicated?: boolean
  minContentCount?: number
  maxContentToReturn?: number
  minTextContentCharacterCount?: number
  minTextContentWordCount?: number
  showProgressBar?: boolean
  truncateLength?: number
  sortOrder?: 'MOST_VOTES' | 'MOST_RECENT' | 'LONGEST'
  widgetDivId?: string
}
export interface GlobalConfig {
  additionalPagingScroll?: number
  authSettings?: AuthSettings
  mediaEnabled?: boolean
  modalHeadingLevel?: number
  multiItemAnswerEnabled?: boolean
  multiItemPickerTitleLength?: number
  pixleeDuhEnabled?: boolean
  siteName?: string
  ssoEnabled?: boolean
}
export interface AuthSettings {
  question?: 1 | 2 | 3
  answerReply?: 1 | 2
  review?: 1 | 3 | 4
}
export interface InstantAnswersConfig {
  headingLevel?: number
  initialPageSize?: number
  pageSize?: number
  learnMoreEnabled?: boolean
  multiItemQuestionEnabled?: boolean
  widgetDivId?: string
}
export interface Layout {
  headerItems?: Array<string>
  columns?: Array<LayoutColumn>
  footerItems?: Array<string>
}
export interface LayoutColumn {
  width?: number
  rightMargin?: number
  items?: Array<string>
}
export interface LayoutConfig {
  breakpoint?: number
  layout?: Layout
}
export interface QaCommentsConfig {
  initialPageSize?: number
  includeSyndicated?: boolean
  limit?: number
  minCount?: number
  minCharacterCount?: number
  minWordCount?: number
  sortOrder?: 0 | 1
  truncateAllowance?: number
  truncateLength?: number
}
export interface QaConfig {
  comments?: QaCommentsConfig
  defaultSortOption?:
    | 'RECENT'
    | 'OLDEST'
    | 'BEST'
    | 'MOST_ANSWERS'
    | 'LEAST_ANSWERS'
    | 'MOST_RECENT_ANSWER'
    | 'OLDEST_ANSWER'
  defaultSortOptionName?:
    | 'RECENT'
    | 'OLDEST'
    | 'BEST'
    | 'MOST_ANSWERS'
    | 'LEAST_ANSWERS'
    | 'MOST_RECENT_ANSWER'
    | 'OLDEST_ANSWER'
  displayUserToolbar?: boolean
  enableLazyLoading?: boolean
  headingLevel?: number
  hideBestAnswer?: boolean
  initialPageSize?: number
  pageSize?: number
  relatedInitialPageSize?: number
  relatedPageSize?: number
  relatedQuestionsDisplay?: 'NONE' | 'INCLUDED' | 'SEPARATE'
  showCheckoutChatterOnQAWidget?: boolean
  sortOptions?: Array<string>
  useShowMore?: boolean
  widgetDivId?: string
}
export interface ReviewBreakpointConfig {
  breakpoint?: number
  layout?: Layout
  mediaSize?: number
  truncateLength?: number
}
export interface ReviewsListConfig {
  breakpoints?: Array<ReviewBreakpointConfig>
  defaultSortOption?: string
  displayUserToolbar?: boolean
  enableFrontEndReviewTranslation?: boolean
  enableLazyLoading?: boolean
  headingLevel?: number
  hideWriteReview?: boolean
  initialPageSize?: number
  pageSize?: number
  relatedInitialPageSize?: number
  relatedPageSize?: number
  relatedReviewsDisplay?: 'NONE' | 'INCLUDED' | 'SEPARATE'
  showPurchaserBadge?: boolean
  sortOptions?: Array<string>
  toggleFiltersDesktop?: boolean
  toggleFiltersMobile?: boolean
  useShowMore?: boolean
  widgetDivId?: string
}
export interface ReviewsSummaryConfig {
  aggregateMetaOn?: boolean
  aggregateJsonLdMetaOn?: boolean
  breakpoints?: Array<LayoutConfig>
  childWidgets?: { [name: string]: any }
  dimFiltersOn?: boolean
  headingLevel?: number
  layouts?: Array<LayoutConfig>
  showRangeMiddle?: boolean
  widgetDivId?: string
}
export interface ReviewSubmissionConfig {
  acceptTermsRequired?: boolean
  deviceFingerprintOn?: boolean
  mediaSizes?: Array<MediaSize>
  recommendRequired?: boolean
  textMinLength?: number
  textMaxLength?: number
  textRequired?: boolean
  showRangeMiddle?: boolean
  showRecommend?: boolean
  showSweepstakes?: boolean
  termsUrl?: string
  titleMaxLength?: number
  titleRequired?: boolean
}
export interface SellerRatingSubmissionConfig {
  textMinLength?: number
  textMaxLength?: number
}
export interface SortOption {
  name?: string
  title?: string
}
export interface SpectrumConfig {
  headingLevel?: number
  widgetDivId?: string
}
export interface TeaserConfig {
  excludeComments?: boolean
  excludeQa?: boolean
  excludeReviews?: boolean
  showAvgRating?: boolean
  widgetDivId?: string
}
export interface TeaserSubdimension {
  dimId?: number
  displayType?: 'TEXT' | 'VISUAL' | 'DISTRIBUTION'
}
export interface SubdimensionTeaserConfig {
  headingLevel?: number
  subdimensions?: Array<TeaserSubdimension>
  minReviews?: number
  widgetDivId?: string
}
export interface TopCommentsConfig {
  includeSyndicated?: boolean
  minCharacterCount?: number
  minWordCount?: number
  truncateLength?: number
  truncateAllowance?: number
}
export interface VcPinboardConfig {
  activeOnly?: boolean
  breakpointsConfig?: Array<VcPinboardBreakpoint>
  hoverTitleMaxLength?: number
  limit?: number
  minCaptionCharCount?: number
  minCaptionWordCount?: number
  maxCaptionLength?: number
  progressiveLoading?: boolean
  showCaption?: boolean
  showDatestamp?: boolean
  showReviewStars?: boolean
  sortOrder?: 'MOST_VOTES' | 'MOST_RECENT' | 'LONGEST'
  userNameMaxLength?: number
  widgetDivId?: string
}
export interface VcPinboardBreakpoint {
  viewport?: number
  minWidth?: number
  maxWidth?: number
  hSpacing?: number
  vSpacing?: number
}
export interface UgcCounts {
  questions?: number
  directQuestions?: number
  answers?: number
  directAnswers?: number
  reviews?: number
  avgRating?: number
  relatedReviews?: number
  comments?: number
  active?: boolean
  hideReviewsDisplay?: boolean
}
export interface EriCampaign {
  campaignKey?: string
  active?: boolean
  incentives?: Array<Incentive>
}
export interface Incentive {
  type?: number
  name?: string
  ugcTier?: number
}

type HttpMethod = 'GET' | 'POST' | 'PUT' | 'DELETE'

function createRestError(xhr: TTXMLHttpRequest): RestError {
  /* beautify ignore:start */
  const restError = {
    status: xhr.status,
    fieldErrors: []
  } as RestError
  /* beautify ignore:end */
  const errorsStr = xhr.getResponseHeader('turnto-error-msg')
  if (xhr.getResponseHeader('turnto-error') && errorsStr) {
    try {
      JSON.parse(errorsStr).forEach((error) => {
        if (error.path) {
          restError.fieldErrors.push(error)
        } else {
          restError.errorCode = error.code
        }
      })
    } catch (e) {
      restError.errorCode = 'unexpected-error'
    }
  } else {
    restError.errorCode = 'unexpected-error'
  }
  return restError
}

function createOfflineRestError(xhr: TTXMLHttpRequest): RestError {
  /* beautify ignore:start */
  return {
    status: xhr.status,
    fieldErrors: [],
    errorCode: 'turnto-offline'
  } as RestError
  /* beautify ignore:end */
}

function populatePathValues(path: string, params: any = {}) {
  const fieldsInPathRegEx = /{(.*?)}/g
  // globally replacing siteKey and locale without needing to pass in calls
  const replaceMap = {
    '{siteKey}': hostsConfig.siteKey,
    '{locale}': turnToConfig.locale
  }
  // this loop finds each path variable and adds to the replaceMap.
  // a path variable is surrounded by curly braces.
  // Example with siteKey and id: /{siteKey}/review/{id}
  let match
  while ((match = fieldsInPathRegEx.exec(path))) {
    const fieldName = match[1]
    if (fieldName !== 'siteKey' && fieldName !== 'locale') {
      replaceMap[`{${fieldName}}`] = params[fieldName]
    }
  }
  // this regex and replace, replaces each path variable with its value
  const replaceRegEx = new RegExp(Object.keys(replaceMap).join('|'), 'gi')
  return path.replace(replaceRegEx, (matched) => replaceMap[matched])
}

export function call<T = any>(
  method: HttpMethod,
  path: string,
  parameters: any = {},
  requiredFields: string[],
  queryFields: string[],
  headerFields: string[],
  body: any = {}
): Promise<T> {
  let queryParameters: any = {}
  let headers: any = {}

  requiredFields.forEach((fieldName) => {
    if (parameters[fieldName] === undefined || parameters[fieldName] === null) {
      throw new Error(`Missing required  parameter: ${fieldName}`)
    }
  })
  queryFields.forEach((fieldName) => {
    if (parameters[fieldName] !== undefined && parameters[fieldName] !== null) {
      queryParameters[fieldName] = parameters[fieldName]
    }
  })
  headerFields.forEach((fieldName) => {
    if (parameters[fieldName] !== undefined && parameters[fieldName] !== null) {
      headers[fieldName] = parameters[fieldName]
    }
  })
  const populatedPath = populatePathValues(path, parameters)

  return new Promise<T>((resolve, reject) => {
    executeRequest(method, populatedPath, {
      body,
      headers,
      params: queryParameters
    })
      .then((xhr) => {
        const offline = xhr.getResponseHeader('turnto-offline')
        if (offline === 'true') {
          reject(createOfflineRestError(xhr))
        } else if (xhr.status === 200 || xhr.status === 201) {
          resolve(xhr.data)
        } else {
          reject(createRestError(xhr))
        }
      })
      .catch((xhr) => {
        reject(createRestError(xhr))
      })
  })
}

export function callStatic<T = any>(
  path: string,
  parameters: any = {},
  requiredFields: string[]
): Promise<T> {
  requiredFields.forEach((fieldName) => {
    if (parameters[fieldName] === undefined || parameters[fieldName] === null) {
      throw new Error(`Missing required  parameter: ${fieldName}`)
    }
  })
  const populatedPath = populatePathValues(path, parameters)

  if (process.env.INCLUDE_STATIC_CACHE && staticCache.getCachedPath(populatedPath)) {
    return staticCache.getCachedPath(populatedPath).promise
  }
  const promise = new Promise<T>((resolve, reject) => {
    executeStaticRequest(populatedPath)
      .then((xhr) => {
        const offline = xhr.getResponseHeader('turnto-offline')
        if (offline === 'true') {
          reject(createOfflineRestError(xhr))
        } else if (xhr.status === 200) {
          resolve(xhr.data)
        } else {
          reject(createRestError(xhr))
        }
      })
      .catch((xhr) => {
        reject(createRestError(xhr))
      })
  })
  if (process.env.INCLUDE_STATIC_CACHE) {
    staticCache.cachePath(populatedPath, promise)
  }
  return promise
}

/**
 * v5 Widget API
 * @class ApiService
 * @param {(string)} [domainOrOptions] - The project domain.
 */
function uploadFile<T = any>(path: string, formData: FormData, progressCallback): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    executeRequest<T>(
      'POST',
      path,
      // progressCallback function updates the progress as it's being uploaded
      { formData, progressCallback }
    )
      .then((xhr) => {
        if (xhr.status === 200 || xhr.status === 201) {
          resolve(xhr.data)
        } else {
          reject(createRestError(xhr))
        }
      })
      .catch((xhr) => {
        reject(createRestError(xhr))
      })
  })
}

export default { uploadFile }
